



























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BaseCalendarVue, { TimeSchedule } from './baseCalendar.vue';
import { Schedule } from '@/modules/studentCalendar';

@Component
export default class extends BaseCalendarVue {

  public dateFormat(date: Date): string {
    return(
      `<span style="display: inline-block;">${date.getFullYear()}年</span>` +
      `<span style="display: inline-block;">${date.getMonth() + 1}月` +
      `<span style="display: inline-block;">${date.getDate()}日</span></span>`
    );
  }

  public firstDate(): Date | null {
    if (!this.viewDate) { return null; }
    return new Date(this.viewDate);
  }

  public lastDate(): Date | null {
    if (!this.viewDate) { return null; }
    const lastDate = new Date(this.viewDate);
    lastDate.setDate(lastDate.getDate() + 1);
    return lastDate;
  }
  private get isEmpty(): boolean {
    return this.events ? this.events.length === 0 : false;
  }

  private getCellClassName(time: number) {
    const isStart = time.toString().indexOf('.') < 0;
    if (isStart) { return 'start'; }
    return 'end';
  }

  private getHtml(schedule: TimeSchedule) {
    return schedule.endTimeIndex - schedule.startTimeIndex > 0 ?
      schedule.dateLongHtml :
      schedule.dateShortHtml;
  }

  private clickTag(eventId: string) {
    this.$emit('click-tag', eventId);
  }
}
